import { Card, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddAdminUser from "./AddOrganization";
import { toast } from "react-toastify";
import ViewOrganization from "./ViewOrganization";
import AddSubscription from "./AddManualSubscription";
import CustomButton from "../../components/CustomButton/CustomButton";

interface PropData {
    data: OrganizationInterface | null
}

export interface OrganizationInterface {
    _id: number
    name: string;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    category?: string | null;
    gstNumber?: string | null;
    logo?: string | null;
    country: string | number | null;
    state: string | number | null;
    city: string | number | null;
    pinCode: string | null;
    address?: string | null;
    status: OrganizationStatus;
    type: OrganizationType;
}

export enum OrganizationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}

export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [
    {
        id: "subscriptionId",
        label: "Subscription id",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "createdAt",
        label: "Purchase Date",
        // minWidth: 170,
        sortable: true,
    },
    {
        id: "fullName",
        label: "Purchase By",
        // minWidth: 170,
        sortable: true,
    },
    {
        id: "email",
        label: "Primary User Email",
        minWidth: 170,
        sortable: true,
    },

    {
        id: "planName",
        label: "Plan Name",
        minWidth: 170,
        sortable: true,
    },

    {
        id: "Amount",
        label: "Amount",
        // minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "Duration",
    //     label: "Duration",
    //     minWidth: 170,
    //     sortable: true,
    // },
    {
        id: "StartDate",
        label: "Start Date",
        // minWidth: 170,
        sortable: true,
    },
    {
        id: "EndDate",
        label: "End Date",
        // minWidth: 170,
        sortable: true,
    },
    {
        id: "status",
        label: "Status",
        // minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "action",
    //     label: "Action",
    //     minWidth: 100,
    //     align: "center" as const,
    // },
];


const Subscription = (props: PropData) => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        subscriptionId: "transaction.orderNo",
        createdAt: "createdAt",
        fullName: "user.fullName",
        email: "user.email",
        planName: "plan.planName",
        Amount: "transaction.totalAmount",
        StartDate: "startDate",
        EndDate: "endDate",
        status: "status",
    };
    const [userObject, setUserObject] = useState<OrganizationInterface | null>(null)
    const [showOrganizationView, setShowOrganizationView] = useState(false);

    const [showAddModal, setShowAddModal] = useState(false);
    const [editData, setEditData] = useState<any>(null);
    const [pagePermission, setPagePermission] = useState({
        canView: false,
        canAdd: false,
        canEdit: false,
        canDelete: false,
    });

    console.log("propsData", props.data);

    useEffect(() => {
        getOrganizationSusbcriptionList();
    }, [currentPage, sortField, sortOrder]);

    const getOrganizationSusbcriptionList = (keyword: string = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", currentPage.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword searches
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        if (!props?.data?._id) {
            setLoading(false);
            return;
        }
        WebService.getAPI({
            action: `organizations/get-subscription-list/${props.data._id}?${params.toString()}`,
        })
            .then((res: any) => {
                const perm = res?.data?.permissions || {};
                setPagePermission({
                    canView: perm.canView,
                    canAdd: perm.canAdd,
                    canEdit: perm.canEdit,
                    canDelete: perm.canDelete,
                });
                const formattedRows = res?.data?.data.map((item: any) => {
                    return {
                        subscriptionId: item.transaction.orderNo,
                        status: item.status,
                        email: item.user.email,
                        planName: item.plan?.planName || "-",
                        Amount: item.transaction?.totalAmount != null
                            ? `₹${Number(item.transaction.totalAmount).toLocaleString("en-IN")}`
                            : "-",
                        // Duration: item.plan?.duration != null ? item.plan.duration : "-",
                        StartDate: item.startDate ? HelperService.getFormatedDate(item.startDate) : "-",
                        EndDate: item.endDate ? HelperService.getFormatedDate(item.endDate) : "-",
                        fullName: item.user?.fullName || "-",
                        createdAt: item.createdAt ? HelperService.getFormatedDate(item.createdAt) : "-",
                        // action: actionList(item), // Uncomment if you want actions
                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching organization subscriptions:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any) =>
    (
        <div>
            <PencilFill className="me-3 cursor-pointer" size={16}
                onClick={() => {
                    setShowAdminBlade(true);
                    setUserObject(item);
                }}
                title="Edit"
            />
            <EyeFill className="me-3 cursor-pointer" size={18}
                onClick={() => {
                    setShowOrganizationView(true);
                    setUserObject(item);
                }}
                title="View"
            />
        </div>
    );
    return (
        <>
            <AddAdminUser show={showAdminBlade}
                handleClose={() => { setShowAdminBlade(false); getOrganizationSusbcriptionList(); setUserObject(null); }}
                data={userObject}
            />
            <ViewOrganization show={showOrganizationView}
                handleClose={() => { setShowOrganizationView(false); getOrganizationSusbcriptionList(); setUserObject(null); }}
                data={userObject}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (leadershipCouncilToDelete) {
                        WebService.deleteAPI({
                            action: `admin-user/delete-admin-user/${leadershipCouncilToDelete}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            toast.success("Admin User deleted successfully.");
                            getOrganizationSusbcriptionList();
                        });
                    }
                }}
                message="Are you sure you want to delete ?"
            />
            <AddSubscription
                show={showAddModal}
                data={props?.data?._id}
                // activeTab={activeTab}
                handleClose={() => {
                    setShowAddModal(false);
                    setEditData(null);
                    getOrganizationSusbcriptionList();
                }}
            />
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                    getOrganizationSusbcriptionList(e.target.value);
                                }}
                            />
                        </div>
                        {/* <div className="col-md-8 d-flex justify-content-end">
                            <CustomButton
                                isLoading={false}
                                label="Add"
                                onClick={() => setShowAddModal(true)}
                                style={{ width: 100, height: 38 }}
                            />
                        </div> */}
                    </div>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <div >
                            <CustomTableSortable
                                columns={columns}
                                rows={leadershipCouncils}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemsPerPage}
                                onPageChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                isLoading={loading}
                                sortField={uiSortField}
                                sortOrder={sortOrder}
                                onSortChange={(columnId, order) => {
                                    setUiSortField(columnId);
                                    setSortOrder(order);
                                    const apiField = sortFieldMap[columnId] || "createdAt";
                                    setSortField(apiField);
                                    setCurrentPage(1);
                                    // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Subscription;
